import "./index.css"
export default function NFT101Card(props) {
    return (
        <div>
            <a href={props.link}><img src={props.src} width={200} height={300}/></a>
        </div>
    )
}